import * as i0 from '@angular/core';
import { Directive, Input, HostListener, NgModule, EventEmitter, Output, HostBinding, Pipe } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/platform-browser';
import { pathOr } from 'ramda';

class BeforeUnloadDirective {
    constructor() {
        this.form = new FormControl();
    }
    handleBrowserUnload($event) {
        if (!this.form.pristine) {
            $event.returnValue = 'You have unsaved changes that will be lost if you leave.';
        }
    }
}
BeforeUnloadDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BeforeUnloadDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
BeforeUnloadDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: BeforeUnloadDirective, selector: "[ngBeforeUnload]", inputs: { form: ["ngBeforeUnload", "form"] }, host: { listeners: { "window:beforeunload": "handleBrowserUnload($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BeforeUnloadDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[ngBeforeUnload]',
                }]
        }], propDecorators: { form: [{
                type: Input,
                args: ['ngBeforeUnload']
            }], handleBrowserUnload: [{
                type: HostListener,
                args: ['window:beforeunload', ['$event']]
            }] } });

class BeforeUnloadModule {
}
BeforeUnloadModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BeforeUnloadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BeforeUnloadModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: BeforeUnloadModule, declarations: [BeforeUnloadDirective], imports: [CommonModule, ReactiveFormsModule], exports: [BeforeUnloadDirective] });
BeforeUnloadModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BeforeUnloadModule, imports: [CommonModule, ReactiveFormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BeforeUnloadModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, ReactiveFormsModule],
                    declarations: [BeforeUnloadDirective],
                    exports: [BeforeUnloadDirective],
                }]
        }] });

class CapsLockDirective {
    constructor() {
        this.targetProperty = false;
        this.utCapsLockChange = new EventEmitter();
        this.caps = false;
    }
    get isCapsLockOn() {
        return this.caps;
    }
    checkForCapsLock(event) {
        this.caps = event.getModifierState('CapsLock');
        this.utCapsLockChange.emit(this.caps);
    }
}
CapsLockDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CapsLockDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
CapsLockDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: CapsLockDirective, selector: "[utCapsLock]", inputs: { targetProperty: ["utCapsLock", "targetProperty"] }, outputs: { utCapsLockChange: "utCapsLockChange" }, host: { listeners: { "keyup": "checkForCapsLock($event)" }, properties: { "class.caps-lock": "this.isCapsLockOn" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CapsLockDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[utCapsLock]' }]
        }], propDecorators: { targetProperty: [{
                type: Input,
                args: ['utCapsLock']
            }], utCapsLockChange: [{
                type: Output
            }], isCapsLockOn: [{
                type: HostBinding,
                args: ['class.caps-lock']
            }], checkForCapsLock: [{
                type: HostListener,
                args: ['keyup', ['$event']]
            }] } });

class CapsLockModule {
}
CapsLockModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CapsLockModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CapsLockModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: CapsLockModule, declarations: [CapsLockDirective], imports: [CommonModule], exports: [CapsLockDirective] });
CapsLockModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CapsLockModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CapsLockModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [CapsLockDirective],
                    exports: [CapsLockDirective],
                }]
        }] });

class ExternalLinkDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    ngOnInit() {
        this.renderer.setAttribute(this.el.nativeElement, 'target', '_blank');
        this.renderer.setAttribute(this.el.nativeElement, 'rel', 'noopener noreferrer');
    }
}
ExternalLinkDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ExternalLinkDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
ExternalLinkDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: ExternalLinkDirective, selector: "[utExternalLink]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ExternalLinkDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[utExternalLink]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; } });

class ExternalLinkModule {
}
ExternalLinkModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ExternalLinkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ExternalLinkModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: ExternalLinkModule, declarations: [ExternalLinkDirective], imports: [CommonModule], exports: [ExternalLinkDirective] });
ExternalLinkModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ExternalLinkModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ExternalLinkModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ExternalLinkDirective],
                    imports: [CommonModule],
                    exports: [ExternalLinkDirective],
                }]
        }] });

class NgLetContext {
    constructor() {
        this.$implicit = null;
        this.ngLet = null;
    }
}
/**
 * @deprecated This is being phased out as usage loses typing information. Replace any usages
 * with the following pattern: *ngIf="{item1: logic, item2: logic...} as varName".
 * Data access example: varName.item1
 */
class NgLetDirective {
    constructor(vcr, templateRef) {
        this.vcr = vcr;
        this.templateRef = templateRef;
        this.context = new NgLetContext();
    }
    set ngLet(value) {
        this.context.$implicit = this.context.ngLet = value;
    }
    ngOnInit() {
        this.vcr.createEmbeddedView(this.templateRef, this.context);
    }
}
NgLetDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NgLetDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
NgLetDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: NgLetDirective, selector: "[ngLet]", inputs: { ngLet: "ngLet" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NgLetDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[ngLet]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: i0.TemplateRef }]; }, propDecorators: { ngLet: [{
                type: Input
            }] } });

/**
 * @deprecated This is being phased out as usage loses typing information. Replace any usages
 * with the following pattern: *ngIf="{item1: logic, item2: logic...} as varName".
 * Data access example: varName.item1
 */
class NgLetModule {
}
NgLetModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NgLetModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgLetModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: NgLetModule, declarations: [NgLetDirective], exports: [NgLetDirective] });
NgLetModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NgLetModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NgLetModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NgLetDirective],
                    exports: [NgLetDirective],
                }]
        }] });

class SafePipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, type) {
        switch (type) {
            case 'html':
                return this.sanitizer.bypassSecurityTrustHtml(value);
            case 'style':
                return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'script':
                return this.sanitizer.bypassSecurityTrustScript(value);
            case 'url':
                return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                throw new RangeError(`Invalid safe pipe type specified: ${type}`);
        }
    }
}
SafePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SafePipe, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
SafePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: SafePipe, name: "safe" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SafePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'safe',
                }]
        }], ctorParameters: function () { return [{ type: i1.DomSanitizer }]; } });

class SafePipeModule {
}
SafePipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SafePipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SafePipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: SafePipeModule, declarations: [SafePipe], imports: [CommonModule], exports: [SafePipe] });
SafePipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SafePipeModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SafePipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SafePipe],
                    exports: [SafePipe],
                }]
        }] });

class ValueByKeyPipe {
    transform(value, key) {
        return pathOr(null, [key], value);
    }
}
ValueByKeyPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ValueByKeyPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ValueByKeyPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: ValueByKeyPipe, name: "valueByKey" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ValueByKeyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'valueByKey',
                }]
        }] });

class ValueByKeyModule {
}
ValueByKeyModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ValueByKeyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ValueByKeyModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: ValueByKeyModule, declarations: [ValueByKeyPipe], imports: [CommonModule], exports: [ValueByKeyPipe] });
ValueByKeyModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ValueByKeyModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ValueByKeyModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ValueByKeyPipe],
                    imports: [CommonModule],
                    exports: [ValueByKeyPipe],
                }]
        }] });

class YesNoPipe {
    transform(value) {
        return !!value ? 'Yes' : 'No';
    }
}
YesNoPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: YesNoPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
YesNoPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: YesNoPipe, name: "psuYesNo" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: YesNoPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'psuYesNo',
                }]
        }] });

class YesNoModule {
}
YesNoModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: YesNoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
YesNoModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: YesNoModule, declarations: [YesNoPipe], imports: [CommonModule], exports: [YesNoPipe] });
YesNoModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: YesNoModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: YesNoModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [YesNoPipe],
                    exports: [YesNoPipe],
                }]
        }] });

/**
 * This utility provides a type guard to inform typescript of typings within an angular template context.
 * Taken from https://angular.io/guide/structural-directives#improving-template-type-checking-for-custom-directives
 *
 * This selector does not start with ut- prefix,
 * the prefix applies to the attribute so that this will apply to Angular's native ng-template elements
 */
// eslint-disable-next-line @angular-eslint/directive-selector
class TypedTemplateContextDirective {
    // the directive gets the template from Angular
    constructor(contentTemplate) {
        this.contentTemplate = contentTemplate;
    }
    // this is how we tell Angular the context type for this directive, which then propagates down to the type of the template
    static ngTemplateContextGuard(dir, ctx) {
        return true;
    }
}
TypedTemplateContextDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TypedTemplateContextDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
TypedTemplateContextDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: TypedTemplateContextDirective, isStandalone: true, selector: "ng-template[utTypedTemplateCtx]", inputs: { typeToken: ["utTypedTemplateCtx", "typeToken"] }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TypedTemplateContextDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'ng-template[utTypedTemplateCtx]', standalone: true }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { typeToken: [{
                type: Input,
                args: ['utTypedTemplateCtx']
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { BeforeUnloadDirective, BeforeUnloadModule, CapsLockDirective, CapsLockModule, ExternalLinkDirective, ExternalLinkModule, NgLetContext, NgLetDirective, NgLetModule, SafePipe, SafePipeModule, TypedTemplateContextDirective, ValueByKeyModule, ValueByKeyPipe, YesNoModule, YesNoPipe };
